enum LABELS {
  TRUE = 'Ja',
  FALSE = 'Nein',
}

/**
 * Formats the given boolean as a human readable string.
 *
 * @param {boolean} val
 * @return {string}
 */
export default (val: boolean): string => (val ? LABELS.TRUE : LABELS.FALSE);
